import React from 'react';
import { Box } from '@mui/material';
import { useConfig } from '../config';

export const HeaderSearch = () => {
  const c = useConfig();
  // const miniBar = isMiniBar(c);
  return (
    <Box
      sx={{
        flex:2,
        ml: 'auto',
        // display: miniBar ? 'none' : 'flex',
        display: 'flex',
        alignItems: 'center',
        width: 1,
        minWidth:300,
        height: c.header.barHeight.mini,
        mt: { xs: 0, sm: 1 },
        mb: { xs: 1, sm: 0 },
      }}
    >
      {/*{!miniBar && c.header.searchBox}*/}
      {c.header.searchBox}
    </Box>
  );
};

export default HeaderSearch;
